import React from 'react';
import configData from "../../../config.json";
import CookieService from '../../../services/CookieService';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory , { Type } from 'react-bootstrap-table2-editor';
import { Button } from 'react-bootstrap';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import '../../home/styleAdminPage.css';
import TreeListObjectGroup from '../Share/TreeListObjectGroup'
import ChiTietGioHang from './ChiTietGioHang'

class DanhSachGioHang extends React.Component<any, any> {
	node: any;
	
	constructor(props:any) {
        super(props);
		this.state = {
			dataJs: [],
			ID_TAS: -5,
			STATUS_VOU: 0
		}
	}
	componentDidMount() {
         
        fetch(
			configData.serviceUrl+ '/api/Admin/GetVoucher?ID_TAS='+ this.props.ID_TAS+'&STATUS_VOU='+this.props.STATUS_VOU ,
			{headers:new Headers ({
				'Access-Control-Allow-Origin' : '*',
                'Authorization' : CookieService.get("access_token") 
			})}
        
        ) 
		    .then(response => response.json())
            .then(dataJs => {
				this.setState({
					dataJs: dataJs.Data
				});
			})
            .catch(e => {
                console.log(e);
				
               
            });
      }

	componentWillMount(){
		
	}

	handleAddRow = () => {
		 
		 
	}

	handleDeleteData = () => {
		try{
           if(this.node.selectionContext.selected.length>0)
		   {
			var result = window.confirm("Có đồng ý xóa "+ this.node.selectionContext.selected.length + " dòng đang chọn?");
			if (result) {
			    
				 this.node.selectionContext.selected.forEach(element => 
					{
						try{
						 
							

						}
						catch(err) {
							console.log("Lỗi xóa: "+err.message);
						}
					}
					);
                   
					//window.location.reload();
			}
			
		   }
		}
		catch(err2) {
			console.log("Lỗi xóa dữ liệu: "+err2.message);
		}
	}

    render(){
        
		const btn1 = {
			width : '100px',
            marginBottom : '5px'
		  }  as const;
		  const btn2 = {
			width : '100px',
			marginLeft : '5px',
            marginBottom : '5px'
		  }  as const;
          const btn3 = {
			width : '200px',
			marginLeft : '5px',
            marginBottom : '5px'
		  }  as const;

		const headerSortingStyle = { backgroundColor: '#c8e6c9' };

		const columns = [
            {
				dataField: 'ID_VOU',
				text: 'Mã đơn hàng',
				sort: true,
				headerSortingStyle,
				filter: textFilter()
			},
			{
                dataField: 'DATE_VOU',
                text: 'Ngày đặt mua',
                sort: true,
			    headerSortingStyle,
                editor: {
                    type: Type.DATE
                },
                formatter: (cell) => {
                    let dateObj = cell;
                    if (typeof cell !== 'object') {
                      dateObj = new Date(cell);
                    }
                    return `${('0' + dateObj.getUTCDate()).slice(-2)}/${('0' + (dateObj.getUTCMonth() + 1)).slice(-2)}/${dateObj.getUTCFullYear()}`;
                }
            },
			{
				dataField: 'ID_OBJ',
				text: 'Mã khách hàng',
				sort: true,
				headerSortingStyle,
				filter: textFilter()
			  },
            {
			dataField: 'NAME_OBJ',
			text: 'Tên khách hàng',
			sort: true,
			headerSortingStyle,
            filter: textFilter()
		  },
		  {
			dataField: 'REPRESENT',
			text: 'Người nhận',
			sort: true,
			headerSortingStyle,
            filter: textFilter()
		  }
		  ,{
			dataField: 'NAME_STA',
			text: 'Tình trạng',
			sort: true,
			headerSortingStyle,
            filter: textFilter()
		  }
		  ,{
			dataField: 'TOTAL_SUM',
			text: 'Tổng tiền',
			type: 'double',
			sort: true,
			headerSortingStyle,
            filter: textFilter()
		  }
		];

		const defaultSorted = [{
			dataField: 'DATE_VOU' ,
			order: 'desc'
		  }];

		  const expandRow = {
			showExpandColumn: true,
			renderer: row => (
			  <div>
				   <ChiTietGioHang NO_VOU={row.NO_VOU} row={row} ModunName={this.props.ModunName}/>
			  </div>
			)
		  };

        return (
				<div id="div_list_content" className="yaallahaa-news-grids-agile">
				
					<Button variant="primary" style={btn3}  onClick={ this.handleDeleteData }>Xóa dòng đang chọn</Button>
					 
                     <BootstrapTable
					    ref={ n => this.node = n }
						keyField='NO_VOU' 
						data={this.state.dataJs} 
						columns={ columns } 
						hover
						condensed
						noDataIndication="Chưa có dữ liệu"
						selectRow={ { mode: 'radio', clickToSelect: true , clickToExpand: true } }
						defaultSorted={ defaultSorted } 
                        filter={ filterFactory() }
                        pagination={ paginationFactory() }
                        wrapperClasses="table-responsive"
						expandRow={ expandRow }
					 />
				</div>
        );
    }

}

export default DanhSachGioHang;
